import heic2any from "heic2any"

export function readImageUrl(input) {
  if (input.files && input.files[0]) {
    const file = input.files[0]
    const ext = file.name.split(".").pop().toLowerCase()

    if (ext === "heic" || ext === "heif") {
      heic2any({
        blob: file,
        toType: "image/jpeg"
      }).then(function (conversionResult) {
        const url = URL.createObjectURL(conversionResult)
        $('#prev_image')
          .attr('src', url)
          .width(250)
          .show();
      }).catch(function (_e) {
        alert('Ocorreu um erro e não foi possível carregar a imagem.')
      })
    } else {
      var reader = new FileReader()
      reader.onload = function (e) {
        $('#prev_image')
          .attr('src', e.target.result)
          .width(250)
          .show()
      }
      reader.readAsDataURL(input.files[0])
    }
  }
}
